import { BusinessBookingOptions } from '@/models/businesses/business-booking-options';
import { axiosService } from '.';

export default class BusinessBookingOptionsService {
    public async getBookingOptions(businessId: number): Promise<BusinessBookingOptions> {
        return new BusinessBookingOptions((await axiosService.instance.get(`businesses/organization/booking-options/${businessId}`)).data);
    }

    public async updateBookingOptions(businessId: number, bookingOptions: BusinessBookingOptions): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/booking-options/${businessId}/update`, bookingOptions)).data;
    }
}

export const businessBookingOptionsService = new BusinessBookingOptionsService();
